
import PropTypes from 'prop-types'
import { createOnFilter } from 'filter'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import MuiFormSelect from 'frame/components/mui-form-select'

const FilterAttributes = ({ filters, filtered, onFilter }) => {
  const hasList = (list) => list && list.length > 0
  const { costCentres, controllers, fleetControllers, fleetNames } = filters
  const controllerOptions = controllers || fleetControllers || []

  const fleetOptions = fleetNames && fleetNames.map(({ value, text }) => {
    return {
      label: text,
      value
    }
  })

  const onSelect = createOnFilter(onFilter)

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingY: 1,
          paddingX: 0,
          cursor: 'pointer',
        }}>
        <Typography variant="h5">Filters</Typography>
      </Box>
      <Divider />
      <Stack gap={2} py={2}>
        {hasList(costCentres) && (
          <MuiFormSelect
            id="costCentre"
            label="Cost Centre"
            options={[{ label: 'No cost centre', value: '-' }, ...costCentres]}
            value={filtered.costCentre}
            onChange={onSelect('costCentre')}
            includeEmptyOption
            emptyOptionLabel="All cost centres" />
        )}
        {hasList(controllerOptions) && (
          <MuiFormSelect
            id="controller"
            label="Controller"
            options={controllerOptions}
            value={filtered.fleetController}
            onChange={onSelect('fleetController')}
            includeEmptyOption />
        )}
        {hasList(fleetOptions) && (
          <MuiFormSelect
            id="fleet"
            label="Fleet"
            options={fleetOptions}
            value={filtered.fleetId}
            onChange={onSelect('fleetId')}
            includeEmptyOption />
        )}
      </Stack>
    </Box>
  )
}

FilterAttributes.propTypes = {
  filters: PropTypes.object.isRequired,
  filtered: PropTypes.object.isRequired,
  onFilter: PropTypes.func.isRequired,
}

export default FilterAttributes
